const ChartIncreaseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
    >
      <path
        d="M9.55334 8.54545C9.55334 8.40079 9.49013 8.26205 9.37761 8.15976C9.26509 8.05747 9.11247 8 8.95334 8H4.15334C3.99421 8 3.8416 8.05747 3.72908 8.15976C3.61656 8.26205 3.55334 8.40079 3.55334 8.54545C3.55334 8.69012 3.61656 8.82886 3.72908 8.93115C3.8416 9.03344 3.99421 9.09091 4.15334 9.09091H8.95334C9.11247 9.09091 9.26509 9.03344 9.37761 8.93115C9.49013 8.82886 9.55334 8.69012 9.55334 8.54545ZM9.55334 11.4545C9.55334 11.3099 9.49013 11.1711 9.37761 11.0689C9.26509 10.9666 9.11247 10.9091 8.95334 10.9091H4.15334C3.99421 10.9091 3.8416 10.9666 3.72908 11.0689C3.61656 11.1711 3.55334 11.3099 3.55334 11.4545C3.55334 11.5992 3.61656 11.7379 3.72908 11.8402C3.8416 11.9425 3.99421 12 4.15334 12H8.95334C9.11247 12 9.26509 11.9425 9.37761 11.8402C9.49013 11.7379 9.55334 11.5992 9.55334 11.4545Z"
        fill="#3B82F6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.68238 0C2.11772 0 1.57619 0.22287 1.17692 0.619582C0.777653 1.01629 0.553345 1.55435 0.553345 2.11538V12.8846C0.553345 13.4457 0.777653 13.9837 1.17692 14.3804C1.57619 14.7771 2.11772 15 2.68238 15H10.4243C10.989 15 11.5305 14.7771 11.9298 14.3804C12.329 13.9837 12.5533 13.4457 12.5533 12.8846V4.39846C12.5533 4.10538 12.4573 3.82077 12.2793 3.58692L9.95825 0.534615C9.83196 0.368551 9.66864 0.233846 9.48111 0.141083C9.29358 0.0483206 9.08696 2.8072e-05 8.87747 0H2.68238ZM1.71464 2.11538C1.71464 1.58462 2.14818 1.15385 2.68238 1.15385H8.29528V4.53615C8.29528 4.85462 8.55541 5.11308 8.87593 5.11308H11.3921V12.8846C11.3921 13.4154 10.9585 13.8462 10.4243 13.8462H2.68238C2.14818 13.8462 1.71464 13.4154 1.71464 12.8846V2.11538Z"
        fill="#3B82F6"
      />
    </svg>
  );
};

export default ChartIncreaseIcon;
